import React from 'react';

import { HStack, Icon, Text } from '@chakra-ui/react';

import STATUS_VARIANTS from './shared';
import type { OverallStatus } from './types';

const StatusPill: React.FC<OverallStatus> = ({ label, variant }) => {
  const variantStyle = STATUS_VARIANTS[variant] ?? STATUS_VARIANTS.processing;
  const { bg, borderColor, color, icon: StatusIcon, iconColor } = variantStyle;

  return (
    <HStack
      spacing={2}
      bg={bg}
      color={color}
      borderRadius="md"
      px={4}
      py={1.5}
      borderWidth="1px"
      borderColor={borderColor}
      boxShadow="xs"
      alignItems="center"
    >
      <Icon as={StatusIcon} boxSize={4} color={iconColor} />
      <Text fontWeight="semibold" fontSize="sm">
        {label}
      </Text>
    </HStack>
  );
};

export default StatusPill;
